/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { AvailablePositionResponse } from '../model'
// @ts-ignore
import type { CurrentPositionByJourneyIdResponse } from '../model'
// @ts-ignore
import type { OccupancyWithJourneyResponse } from '../model'
// @ts-ignore
import type { OpenJourneyPositionsResponse } from '../model'
// @ts-ignore
import type { StackInRequest } from '../model'
// @ts-ignore
import type { StackOutRequest } from '../model'
/**
 * OccupanciesApi - axios parameter creator
 */
export const OccupanciesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} journeyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availablePositions: async (
      journeyId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'journeyId' is not null or undefined
      assertParamExists('availablePositions', 'journeyId', journeyId)
      const localVarPath = `/yard/api/Occupancies/AvailablePositions/{journeyId}`.replace(
        `{${'journeyId'}}`,
        encodeURIComponent(String(journeyId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} journeyId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    currentPosition: async (
      journeyId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'journeyId' is not null or undefined
      assertParamExists('currentPosition', 'journeyId', journeyId)
      const localVarPath = `/yard/api/Occupancies/CurrentPosition/{journeyId}`.replace(
        `{${'journeyId'}}`,
        encodeURIComponent(String(journeyId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOccupancies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Occupancies`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [journeyId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    openJourneyPositions: async (
      journeyId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Occupancies/OpenJourneyPositions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (journeyId !== undefined) {
        localVarQueryParameter['journeyId'] = journeyId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {StackInRequest} [stackInRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stackIn: async (
      stackInRequest?: StackInRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Occupancies/StackIn`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        stackInRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {StackOutRequest} [stackOutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stackOut: async (
      stackOutRequest?: StackOutRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Occupancies/StackOut`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        stackOutRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * OccupanciesApi - functional programming interface
 */
export const OccupanciesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OccupanciesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} journeyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async availablePositions(
      journeyId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailablePositionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.availablePositions(
        journeyId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['OccupanciesApi.availablePositions']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} journeyId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async currentPosition(
      journeyId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentPositionByJourneyIdResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.currentPosition(journeyId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['OccupanciesApi.currentPosition']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOccupancies(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OccupancyWithJourneyResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOccupancies(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['OccupanciesApi.getOccupancies']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [journeyId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async openJourneyPositions(
      journeyId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OpenJourneyPositionsResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.openJourneyPositions(
        journeyId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['OccupanciesApi.openJourneyPositions']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {StackInRequest} [stackInRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stackIn(
      stackInRequest?: StackInRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.stackIn(stackInRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['OccupanciesApi.stackIn']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {StackOutRequest} [stackOutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stackOut(
      stackOutRequest?: StackOutRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.stackOut(stackOutRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['OccupanciesApi.stackOut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * OccupanciesApi - factory interface
 */
export const OccupanciesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OccupanciesApiFp(configuration)
  return {
    /**
     *
     * @param {number} journeyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availablePositions(
      journeyId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<AvailablePositionResponse> {
      return localVarFp
        .availablePositions(journeyId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} journeyId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    currentPosition(
      journeyId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CurrentPositionByJourneyIdResponse> {
      return localVarFp
        .currentPosition(journeyId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOccupancies(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<OccupancyWithJourneyResponse>> {
      return localVarFp.getOccupancies(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [journeyId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    openJourneyPositions(
      journeyId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<OpenJourneyPositionsResponse>> {
      return localVarFp
        .openJourneyPositions(journeyId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {StackInRequest} [stackInRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stackIn(stackInRequest?: StackInRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.stackIn(stackInRequest, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {StackOutRequest} [stackOutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stackOut(
      stackOutRequest?: StackOutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp.stackOut(stackOutRequest, options).then(request => request(axios, basePath))
    },
  }
}

/**
 * OccupanciesApi - object-oriented interface
 */
export class OccupanciesApi extends BaseAPI {
  /**
   *
   * @param {number} journeyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public availablePositions(journeyId: number, options?: RawAxiosRequestConfig) {
    return OccupanciesApiFp(this.configuration)
      .availablePositions(journeyId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} journeyId
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public currentPosition(journeyId: number, options?: RawAxiosRequestConfig) {
    return OccupanciesApiFp(this.configuration)
      .currentPosition(journeyId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getOccupancies(options?: RawAxiosRequestConfig) {
    return OccupanciesApiFp(this.configuration)
      .getOccupancies(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [journeyId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public openJourneyPositions(journeyId?: number, options?: RawAxiosRequestConfig) {
    return OccupanciesApiFp(this.configuration)
      .openJourneyPositions(journeyId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {StackInRequest} [stackInRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public stackIn(stackInRequest?: StackInRequest, options?: RawAxiosRequestConfig) {
    return OccupanciesApiFp(this.configuration)
      .stackIn(stackInRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {StackOutRequest} [stackOutRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public stackOut(stackOutRequest?: StackOutRequest, options?: RawAxiosRequestConfig) {
    return OccupanciesApiFp(this.configuration)
      .stackOut(stackOutRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
